// removed by extract-text-webpack-plugin
module.exports = {"footer":"_23otJWk7cbbmVLD-5wHOCq","footerBtn":"_2O-xCtipUbWu21AniXOf7v","form":"_7U_bLrN0fv5I3DxnTbuUi"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OasisTokenWrapForm.scss
// module id = 1308
// module chunks = 0